<script>
import moment from 'moment';

import FileManagerListDisplay from './FileManagerListDisplay'
import FileManagerGridDisplay from './FileManagerGridDisplay'

export default {
  components: { FileManagerListDisplay, FileManagerGridDisplay },
  props: ['filters'],
  data() {
    return {
      uploading: false,
      showProgress: 0,
      sizelimit: 100,
      errors: [],

      cur_item : {},

      default_new_directory: {
        name: '',
        start_dir: '',
        dir: '',
      },
      new_directory: {},

      layout: 'grid',
      loading: false,
      loading_action: false,
      results: [],
      pagination: {},

      formats: {
        images: ['apng','avif','gif','jpg','jpeg','jfif','pjpeg','pjp','png','svg','webp','bmp','ico','cur','tif','tiff'],
        audios: ['wav','mp3','ogg','aac','midi'],
        videos: ['mp4','m4v','mov','ogv','fla','flv','webm','asf','avi','wmv','mpg','mpeg'],
        docs: ['doc','dot','wbk','docx','docm','dotx','dotm','docb'],
        powerpoints: ['ppt','pot','pps','pptx','pptm','potx','potm','ppam','ppsx','ppsm','sldx','sldm'],
        spreadsheets: ['xls','xlt','xlm','xlsx','xlsm','xltx','xltm','xlsb','xla','xlam','xll','xlw'],
        archives: ['zip','rar','gz','tar'],
      },
    }
  },
  computed: {
    dir_parts: function () {
      var parts = this.filters.dir.replace(/^\/+|\/+$/g, '').split('/'), build_path = '', out = [{path:'/',name:'Home'}];
      if(parts.length) {
        for(var i in parts) {
          if(parts[i]) {
            build_path = build_path+'/'+parts[i];
            out.push({path:build_path,name:parts[i]});
          }
        }
      }
      return out;
    }
  },
  watch: {
    'loading': { handler: function(n, o) { this.$emit('loadchange', n) }},
    'filters.dir': { handler: function(n, o) { this.pagination.current_page = 1; this.fetchData(); }},
    'filters.paginate': { handler: function(n, o) { this.pagination.current_page = 1; this.fetchData(); }},
  },
  created() {
    this.new_directory = JSON.parse(JSON.stringify(this.default_new_directory));
    this.fetchData();
  },
  methods: {
    fetchData() {
      this.loading = true;
      this.filters.page = this.pagination.current_page;
      this.$http.get('/api/file-manager/fetch', {params: this.filters}).then(res => {
        // console.log(res);
        this.results = res.data.data;
        this.pagination = res.data;
        this.filters.total = res.data.total;
        this.loading = false;
      }).catch(res => { this.results = []; this.loading = false; this.popupErrors(res); });
    },
    upload_files(event) {
      var $this = this;
      this.uploading = true;
      var count = 0, toadd = event.target.files.length, files = [];
      this.errors = [];
      Array.prototype.push.apply(files, event.target.files);
      var i = files.length; while(i--) { if(files[i].size > ((1024 * 1024) * this.sizelimit)){
        this.errors.push(files[i].name+' is to large. File cannot exceed '+this.sizelimit+'mb.'); files.splice(i, 1);
      } }
      toadd = files.length;
      if(toadd > 20) { toadd = 20; this.errors.push('There is a 20 files per upload limit. Please upload the additional files once this upload is complete.'); }
      if(toadd < 1){ this.$noty.success('0 photo(s) added'); this.uploading = false; return; }
      const fd = new FormData();
      fd.append("start_dir", this.filters.start_dir);
      fd.append("dir", this.filters.dir);
      for(var i = 0; i < files.length; i++){ if(i > 19){ continue; } count++; fd.append('files[' + i + ']', files[i]); }
      this.$http.post('/api/file-manager/store', fd, {onUploadProgress(e) {
        const totalLength = e.lengthComputable ? e.total : e.target.getResponseHeader('content-length') || e.target.getResponseHeader('x-decompressed-content-length');
        if(totalLength !== null) {
          $this.showProgress = Math.round( (e.loaded * 100) / totalLength );
        }
      }}).then(res => {
        // console.log(res);
        if(res.data && res.data.message) { this.$noty.success(res.data.message); }
        if(res.data.errors && res.data.errors.length) { for(var i in res.data.errors) { this.$noty.error(res.data.errors[i]); } }
        this.fetchData();
        this.uploading = false;
      }).catch(res => { this.uploading = false; this.$noty.warning('Failed to add file(s)'); });
    },
    delete_file(item) {
      if(this.loading_action || this.loading) { this.$noty.warning('Please wait until loading has finished.'); return; } this.loading_action = true;
      if(!item.type) { this.$noty.warning('File/Directory not found'); this.loading_action = false; return; }
      if(item.type == 'Folder') {
        var da_message = 'Are you sure you want to delete this directory? All files and directories inside this directory will be deleted as well.';
      } else {
        var da_message = 'Are you sure you want to delete this item?';
      }
      var n = this.$noty.error(da_message, { timeout: false, modal: true, type: 'default', layout: 'center', closeWith: ['button'],
        buttons: [
          Noty.button('YES', 'btn btn-block btn-light m-r-5', res2 => {
            if(this.disabled) { this.$noty.warning('Please wait until loading has finished.'); return; } this.disabled = true;
            this.$http.delete('/api/file-manager/delete', {params: item}).then(res => {
              // console.log(res);
              if(res.data && res.data.message) { this.$noty.success(res.data.message); }
              if(res.data.errors && res.data.errors.length) { for(var i in res.data.errors) { this.$noty.error(res.data.errors[i]); } }
              this.fetchData();
              this.disabled = false;
              n.close();
            }).catch(res => { this.popupErrors(res); this.loading = false; this.disabled = false; });
          }, {id: 'button1', 'data-status': 'ok'}),
        ]
      }).on('onClose', () => { this.loading_action = false; this.disabled = false; });
    },
    add_directory() {
      if(this.loading_action || this.loading) { this.$noty.warning('Please wait until loading has finished.'); return; } this.loading_action = true;
      this.new_directory.start_dir = this.filters.start_dir;
      this.new_directory.dir = this.filters.dir;
      this.$http.post('/api/file-manager/directory/store', this.new_directory).then(res => {
        // console.log(res);
        this.new_directory = JSON.parse(JSON.stringify(this.default_new_directory));
        if(res.data && res.data.message) { this.$noty.success(res.data.message); }
        if(res.data.errors && res.data.errors.length) { for(var i in res.data.errors) { this.$noty.error(res.data.errors[i]); } }
        this.fetchData();
        this.$refs.modal_add_directory.hide();
        this.loading_action = false;
      }).catch(res => { this.loading_action = false; this.popupErrors(res); });
    },
    view_file(item) {
      if(this.loading_action || this.loading) { this.$noty.warning('Please wait until loading has finished.'); return; }
      if(item.type == 'Folder') {
        this.filters.dir = this.filters.dir+'/'+item.name;
      } else if(
        this.formats.images.includes(item.type)
        || this.formats.audios.includes(item.type)
        || this.formats.videos.includes(item.type)
        || item.type == 'pdf'
      ) {
        window.open(item.url, '', 'width=640,height=480');
      } else {
        this.$noty.warning('This file format is not viewable. Please download instead.');
      }
    },
    renameFile(item) {
      this.cur_item = item;
      this.cur_item.new_name = this.cur_item.name;
      this.$refs.modal_rename_file.show();
    },
    rename_file() {
      if(this.loading_action || this.loading) { this.$noty.warning('Please wait until loading has finished.'); return; } this.loading_action = true;
      this.$http.put('/api/file-manager/rename', this.cur_item).then(res => {
        // console.log(res);
        this.cur_item = {};
        if(res.data && res.data.message) { this.$noty.success(res.data.message); }
        if(res.data.errors && res.data.errors.length) { for(var i in res.data.errors) { this.$noty.error(res.data.errors[i]); } }
        this.fetchData();
        this.$refs.modal_rename_file.hide();
        this.loading_action = false;
      }).catch(res => { this.loading_action = false; this.popupErrors(res); });
    },
    downloadFiles(item) {
      if(this.loading_action || this.loading) { this.$noty.warning('Please wait until loading has finished.'); return; } this.loading_action = true;
      this.cur_item = item;
      this.$http.get('/api/file-manager/download', {params: this.cur_item, responseType: 'arraybuffer'}).then(res => {
        // console.log(res);
        var newBlob = new Blob([res.data], {type: res.headers['content-type']});
        if(window.navigator && window.navigator.msSaveOrOpenBlob) { window.navigator.msSaveOrOpenBlob(newBlob); return; }
        const data = window.URL.createObjectURL(newBlob);
        var link = document.createElement('a'); link.href = data; link.download = (this.cur_item.type == 'Folder' ? this.cur_item.name+'.zip' : this.cur_item.name); link.click();
        setTimeout(function () { window.URL.revokeObjectURL(data) }, 100);
        this.loading_action = false;
      }).catch(res => { this.popupErrors(res); this.loading_action = false; });
    },
    viewProperties(item) {
      this.cur_item = item;
      this.$refs.modal_file_properties.show();
    },
    copyThis(item) {
      const el = document.createElement('textarea');
      el.value = item;
      el.setAttribute('readonly', '');
      el.style.position = 'absolute';
      el.style.left = '-9999px';
      document.body.appendChild(el);
      const selected =  document.getSelection().rangeCount > 0  ? document.getSelection().getRangeAt(0) : false;
      el.select();
      document.execCommand('copy');
      document.body.removeChild(el);
      if(selected) {
        document.getSelection().removeAllRanges();
        document.getSelection().addRange(selected);
      }
      this.$noty.success('Copied to clipboard');
    }
  }
}
</script>

<template>

  <div class="card-box p-0 position-relative">
    <transition name="fade">
      <div class="ribbon-two ribbon-two-primary" :key="1" v-if="loading || loading_action"><span><i class="spinner-border spinner-border-sm"></i></span></div>
    </transition>

    <b-modal ref="modal_rename_file" centered size="lg" :title="cur_item.name" :no-close-on-backdrop="true" :no-close-on-esc="true" :hide-footer="true">
      <b-form @submit.prevent="rename_file">
        <div class="p-3">
          <div class="row">
            <div class="col-sm-12">
              <b-form-group label="New name:" label-for="input-name" description="Please enter a new name for the file.">
                <b-form-input id="input-name" v-model="cur_item.new_name" type="text" placeholder="Enter name" required></b-form-input>
              </b-form-group>
            </div>
          </div>
        </div>
        <footer class="modal-footer modal-footer-custom">
          <button type="button" class="btn btn-white" @click="$refs.modal_rename_file.hide()">Cancel</button>
          <button type="submit" class="btn btn-primary">Submit</button>
        </footer>
      </b-form>
    </b-modal>

    <b-modal ref="modal_file_properties" centered size="lg" :title="cur_item.name" :no-close-on-backdrop="true" :no-close-on-esc="true" :hide-footer="true">
      <div class="p-3">
        <div class="table-responsive">
          <table class="table table-sm table-px-0">
            <tbody>
              <tr v-if="cur_item.name"><th class="border-0 _w-n-150">File name :</th><td class="border-0 _w-n-150">{{cur_item.name}}</td></tr>
              <tr v-if="cur_item.url"><th>URL :</th><td>{{cur_item.url}}</td></tr>
              <tr v-if="cur_item.type"><th>Type :</th><td>{{cur_item.type}}</td></tr>
              <tr v-if="cur_item.size"><th>Size :</th><td>{{formatSize(cur_item.size)}}</td></tr>
              <tr v-if="cur_item.date"><th>Modified on :</th><td>{{cur_item.date}}</td></tr>
            </tbody>
          </table>
        </div>
      </div>
      <footer class="modal-footer modal-footer-custom">
        <button type="button" class="btn btn-light" @click="$refs.modal_file_properties.hide()">Cancel</button>
      </footer>
    </b-modal>

    <div class="bg-white sticky-menu">
      <div class="sticky-menu-child border-bottom border-light bg-white _z-100">
        <div class="d-flex">
          <div class="mr-auto p-3">
            <form class="form-inline">
              <button type="button" class="btn btn-white mr-1" :disabled="!filters.dir" @click="!loading && filters.dir ? filters.dir = '' : ''" v-tippy content="Return to the home directory"><Icon icon="ri:home-2-line" width="17" /></button>
              <button type="button" class="btn btn-white mr-1" :disabled="dir_parts.length < 2" @click="!loading && dir_parts.length > 1 ? filters.dir = dir_parts[(dir_parts.length - 1) - 1].path : ''" v-tippy content="Go back one directory"><Icon icon="ri:rewind-line" width="17" /></button>
              <button type="button" class="btn btn-white mr-2" @click="fetchData()" v-tippy content="Refresh the file manager"><Icon icon="ri:refresh-line" width="17" /></button>
              <div class="_h-40 _w-1 border-left mr-2"></div>

              <div v-if="!uploading">
                <button type="button" class="btn btn-success mr-1" @click="$refs.fileInput.click()" v-tippy content="Upload file(s). Limited to 20 files per upload. 100mb per file."><Icon icon="ri:upload-2-line" width="17" /></button>
                <input class="d-none" ref="fileInput" type="file" @change="upload_files" multiple>
              </div>

              <button type="button" class="btn btn-success mr-1" @click="new_directory = JSON.parse(JSON.stringify(default_new_directory)); $refs.modal_add_directory.show()" v-tippy content="Create a directory"><Icon icon="ri:folder-6-line" width="17" /></button>
              <b-modal ref="modal_add_directory" centered size="lg" title="Create a new directory" :no-close-on-backdrop="true" :no-close-on-esc="true" :hide-footer="true">
                <b-form @submit.prevent="add_directory">
                  <div class="p-3">
                    <div class="row">
                      <div class="col-sm-12">
                        <b-form-group label="Name:" label-for="input-name" description="Please enter a name for the new directory.">
                          <b-form-input id="input-name" v-model="new_directory.name" type="text" placeholder="Enter name" required></b-form-input>
                        </b-form-group>
                      </div>
                    </div>
                  </div>
                  <footer class="modal-footer modal-footer-custom">
                    <button type="button" class="btn btn-light" @click="$refs.modal_add_directory.hide()">Cancel</button>
                    <button type="submit" class="btn btn-primary">Submit</button>
                  </footer>
                </b-form>
              </b-modal>
            </form>
          </div>
          <div class="p-3">
            <button type="button" class="btn btn-light bg-white border ml-1 _py-5 _px-7" @click="layout = 'list'" v-tippy content="Switch to list display"><Icon icon="ri:list-check" width="17" /></button>
            <button type="button" class="btn btn-light bg-white border ml-1 _py-5 _px-7" @click="layout = 'grid'" v-tippy content="Switch to grid display"><Icon icon="ri:layout-grid-fill" width="17" /></button>
          </div>
        </div>
      </div>
    </div>

    <div v-if="uploading" class="progress _h-40">
      <div class="progress-bar progress-bar-striped progress-bar-animated bg-primary font-weight-bold" :style="'width:'+showProgress+'%'">UPLOADING {{showProgress}}%</div>
    </div>

    <div v-if="errors.length">
      <div v-for="(error, index) in errors" :key="index" class="alert alert-warning">
        <Icon icon="ri:close-fill" @click="errors.splice(index, 1)" v-tippy content="Close" /> {{error}}
      </div>
    </div>

    <div class="border-bottom border-light px-3">
      <ol class="breadcrumb m-0">
        <li class="breadcrumb-item" v-for="(item, item_i) in dir_parts" :key="item_i" :class="item_i+1 == dir_parts.length ? 'active' : '_c-pointer'" @click="item_i+1 != dir_parts.length && !loading ? filters.dir = item.path : ''" v-tippy :content="item_i+1 == dir_parts.length ? '' : 'Return to this directory'">{{item.name}}</li>
      </ol>
    </div>

    <FileManagerListDisplay
      v-if="layout == 'list'"
      :loading="loading"
      :filters="filters"
      :results="results"
      :formats="formats"
      @copy="(e) => { copyThis(e) }"
      @viewfile="(e) => { view_file(e) }"
      @downloadfiles="(e) => { downloadFiles(e) }"
      @renamefile="(e) => { renameFile(e) }"
      @viewproperties="(e) => { viewProperties(e) }"
      @deletefile="(e) => { delete_file(e) }"
    ></FileManagerListDisplay>

    <FileManagerGridDisplay
      v-else-if="layout == 'grid'"
      :loading="loading"
      :filters="filters"
      :results="results"
      :formats="formats"
      @copy="(e) => { copyThis(e) }"
      @viewfile="(e) => { view_file(e) }"
      @downloadfiles="(e) => { downloadFiles(e) }"
      @renamefile="(e) => { renameFile(e) }"
      @viewproperties="(e) => { viewProperties(e) }"
      @deletefile="(e) => { delete_file(e) }"
    ></FileManagerGridDisplay>

    <div class="p-3 border-top border-light">
      <w-pagination :pagination="pagination" @paginate="results=[]; fetchData()" :offset="4"></w-pagination>
    </div>

  </div>

</template>
